import { LOW_FLOOR_DEALS } from '../sharedConfig';

// budgetAllocation values are relative weights, NOT percentages.
// The formula (weight / sumOfSelectedWeights) × sourceBudget distributes 100%
// of the source line item's budget across whichever items are enabled.
export default {
  key: 'constructionStaffing',
  label: 'Construction Staffing',
  strategySets: {
    default: {
      label: 'Standard (3 items)',
      lineItems: [
        { name: 'CPM_Broad_OpenTargeting_18Plus_18plusonlyOEOnly_DIS_Prospecting', segment: 'AGE_18_PLUS_BROAD', budgetAllocation: 80 },
        { name: 'CPM_RET_Geo_Onspot_18plusonlyOEOnly_DIS_Retargeting', segment: 'ON_SPOT_18_PLUS', budgetAllocation: 10 },
        { name: 'CPM_RET_PVBeacon_x_18plusonlyOEOnly_DIS_Retargeting', segment: null, budgetAllocation: 10 },
      ],
    },
  },
  deals: LOW_FLOOR_DEALS,
};
